

































































































































































import {
    myVue
} from "@/components/class/myVue";
import {
    Component
} from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    add() {
        // this.current.add()
        this.current.addData()
    }
    moveIndex(edit_index: any) {
        let newValue: any[] = JSON.parse(this.current.valueFormat())
        if (utils.isNull(newValue)) {
            newValue = utils.lodash.cloneDeep(this.current.value)
        }
        newValue[edit_index] = {
            color: "",
            id: "",
            material_quality: "",
            name: "",
            note: "",
            number: "",
            part_id: "",
            process_part_no: "",
            specifications: "",
            surface_treatment: "",
            url: "[]"
        }
        this.current.value = newValue
    }
    reIndex(edit_index: any) {
        let newValue: any[] = JSON.parse(this.current.valueFormat())
        if (utils.isNull(newValue)) {
            newValue = utils.lodash.cloneDeep(this.current.value)
        }
        utils.lodash.pullAt(newValue, edit_index);
        if (this.current.editMove) {
            let zimu = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q",
                "R", "S", "T", "U", "V", "W", "X", "Y", "Z"
            ]
            for (let index in newValue) {
                let strlength = newValue[index].process_part_no.length - 1
                newValue[index].process_part_no = newValue[index].process_part_no.substring(0, strlength) +
                    zimu[index]
            }
        }
        this.current.value = newValue
    }

    ShowImg(file: any) {
        this.current.file_ol = file
        this.current.img_show = true;
    }

    Download(file: any) {
        utils.myDownload({
            fileName: file.name,
            apiName_download: file.url
        })
    }

    beforeAvatarUpload(file: any) {
        this.current.loading = true
    }
    // 删除图片
    handleRemove(file: any, fileList: any, index: any) {
        this.current.loading = false
        console.log(file)
        console.log(fileList)
        console.log(index)
        //   this.tableData3[index].file = ''
    }

    // 图片上传
    handleSuccess(res: any, file: any, fileList: any, index: any) {
        this.current.loading = false
        console.log(res)
        console.log(file)
        console.log(fileList)
        console.log(index)
        let newValue: any[] = []
        if (utils.isNull(fileList)) {
            this.current.value[index].url = newValue
            return
        }
        for (let l = 0; l < fileList.length; l++) {
            if (fileList[l].response && fileList[l].response.list && fileList[l].response.list[0].url) {
                newValue.push({
                    "url": "/api/" + fileList[l].response.list[0].url,
                    "name": fileList[l].response.list[0].name
                })
            } else {
                newValue.push(fileList[l])
            }
        }
        this.current.value[index].url = newValue
        console.log(this.current.value)
    }
    success(response: any, file: any, fileList: any) {
        console.log(response)
        console.log(file)
        console.log(fileList)
        this.current.loading = false
        // let newValue: any[] = []
        // if (utils.isNull(fileList)) {
        //     this.current.value = newValue
        //     return
        // }
        // for (let l = 0; l < fileList.length; l++) {
        //     if (fileList[l].response && fileList[l].response.list && fileList[l].response.list[0].url) {
        //         newValue.push({
        //             "url": "/api/" + fileList[l].response.list[0].url,
        //             "name": fileList[l].response.list[0].name
        //         })
        //     } else {
        //         newValue.push(fileList[l])
        //     }
        // }
        // this.current.value = newValue
    }

    deleteImg(file: any) {
        let newValue: any[] = []
        for (let l = 0; l < this.current.value.length; l++) {
            if (file.name != this.current.value[l].name) {
                newValue.push(this.current.value[l])
            }
        }
        this.current.value = newValue
    }

    editImg(file: any) {
        this.current.text_show = true;
        this.current.file_ol = file;
    }
}
